"use strict";
/**
 * @fileoverview Product Variant Type Definitions
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantRsdPrice = getVariantRsdPrice;
exports.getVariantEurPrice = getVariantEurPrice;
const Article_js_1 = require("./Article.js");
/**
 * Backward-compatible RSD price accessor for a variant.
 * Tries prices[] first; falls back to legacy scalar `price` field for old MongoDB documents.
 */
function getVariantRsdPrice(variant) {
    var _a;
    if (variant.prices && variant.prices.length > 0) {
        return (0, Article_js_1.getRsdPrice)(variant.prices);
    }
    return (_a = variant.price) !== null && _a !== void 0 ? _a : 0;
}
/**
 * Returns the EUR price for a variant, or undefined if the variant is RSD-priced.
 */
function getVariantEurPrice(variant) {
    if (!variant.prices || variant.prices.length === 0)
        return undefined;
    return (0, Article_js_1.getEurPrice)(variant.prices);
}
